<svg xmlns="http://www.w3.org/2000/svg"
     class="board"
     [attr.viewBox]="viewBoxString()"
     preserveAspectRatio="xMidYMid meet">
    @for (line of board; track $index; let y = $index) {
        <g>
            @for (currentSquare of line; track $index; let x = $index) {
                <g id="click-{{ x }}-{{ y }}"
                   (click)="onClick(x, y)">
                    <rect class="base"
                          [attr.x]="SPACE_SIZE * x"
                          [attr.y]="SPACE_SIZE * y"
                          [attr.width]="SPACE_SIZE"
                          [attr.height]="SPACE_SIZE"/>
                    @if (currentSquare !== EMPTY) {
                        <circle class="base"
                                [attr.cx]="(SPACE_SIZE * x) + (SPACE_SIZE / 2)"
                                [attr.cy]="(SPACE_SIZE * y) + (SPACE_SIZE / 2)"
                                [attr.r]="(SPACE_SIZE / 2) - STROKE_WIDTH"
                                [ngClass]="getSquareFillClass(x, y)"
                                pointer-events="fill"/>
                    }
                </g>
            }
        </g>
    }
    @if (last.isPresent()) {
        <rect class="base no-fill last-move-stroke mid-stroke"
              [attr.x]="SPACE_SIZE * last.get().x"
              [attr.y]="SPACE_SIZE * last.get().y"
              [attr.width]="SPACE_SIZE"
              [attr.height]="SPACE_SIZE"/>
    }
    @for (coord of victoryCoords; track coord.toString()) {
        <rect id="victory-coord-{{ coord.x }}-{{ coord.y }}"
              class="base no-fill victory-stroke mid-stroke"
              [attr.x]="SPACE_SIZE * coord.x"
              [attr.y]="SPACE_SIZE * coord.y"
              [attr.width]="SPACE_SIZE"
              [attr.height]="SPACE_SIZE"/>
    }
</svg>
